<template>
    <div class="relative" dusk="ColorButton">
        <BaseButton
            class="text-theme-toolbar-icon"
            :tooltip="localizations[lang].tooltips.createHighlight"
            :icon-custom-style="iconColorStyle"
            icon="highlighter-24px"
            type="button"
            @click="toggleColorsMenu"
        />
        <transition name="slide-fade">
            <ListDropdown
                v-show="showColorsItems"
                class="left-[-9px] text-theme-toolbar-icon"
                :submenu-display-in-down="submenuDisplayInDown"
            >
                <div class="flex whitespace-nowrap break-keep">
                    <button
                        v-for="color in defaultColors"
                        :key="color.name"
                        v-tooltip="color.lang"
                        :aria-label="localizations[lang][color.lang] || color.lang"
                        :aria-pressed="currentHighlight.color === color.code"
                        class="duration-250 mx-2 block h-[26px] max-h-[26px] min-h-[26px] w-[26px] min-w-[26px] max-w-[26px] cursor-pointer rounded-full transition-opacity ease-in-out hover:opacity-80 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        :class="colorClasses(color)"
                        :data-color-name="color.name"
                        data-color-code="color.code"
                        :style="{ color: color.code, backgroundColor: color.code }"
                        @click.stop="applyColorAndConfirmSelection(color.code)"
                    ></button>
                    <button
                        v-if="currentHighlight.canBeDeleted()"
                        v-tooltip="localizations[lang].tooltips.deleteHighlight"
                        :aria-label="localizations[lang].tooltips.deleteHighlight"
                        class="h-[26px] cursor-pointer p-[2px] focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        @click.stop="deleteSelection"
                    >
                        <svg-icon icon="water-drop" width="26px" height="26px" />
                    </button>
                </div>
            </ListDropdown>
        </transition>
    </div>
</template>
<script>
import BaseButton from '../../Components/buttons/BaseButton.vue';
import ListDropdown from '../../Components/list/ListDropdown.vue';
import { mapState } from 'vuex';

export default {
    components: {
        BaseButton,
        ListDropdown,
    },
    props: {
        applyColorAndConfirmSelection: {
            type: Function,
            required: true,
        },
        toggleColorsMenu: {
            type: Function,
            required: true,
        },
        showColorsItems: {
            type: Boolean,
            required: true,
        },
        submenuDisplayInDown: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['delete-selection'],
    computed: {
        ...mapState(['ui', 'localizations', 'currentHighlight', 'lang', 'defaultColors']),
        iconColorStyle() {
            return {
                color: this.currentHighlight.color ? this.currentHighlight.color : 'transparent',
            };
        },
    },
    methods: {
        colorClasses(color) {
            return {
                'relative transition-transform duration-50 ease-in': this.currentHighlight.color === color.code,
                "after:content-[''] after:top-0 after:left-0 after:absolute after:w-[26px] after:h-[26px] after:border after:border-solid after:border-2 after:border-current after:rounded-full after:scale-120":
                    this.currentHighlight.color === color.code,
            };
        },
        deleteSelection() {
            this.$emit('delete-selection');
        },
    },
};
</script>
